export const NETSUITE_PAGE_TITLE = "Connect to your Netsuite Instance";
